import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SiteContext } from '../../contexts/SiteContext';

export default function TermsOfService() {
  const { t } = useTranslation();
  const { website } = useContext(SiteContext);

  const SITE    = website?.title || t('legal.terms.fallbackSite', { defaultValue: 'Your Website' });
  const UPDATED = '2025-10-08';

  return (
    <div className="max-w-4xl mx-auto bg-white border rounded shadow p-6 md:p-8">
      <h1 className="text-3xl font-bold mb-2">{t('legal.terms.title')}</h1>
      <p className="text-sm text-gray-500 mb-8">
        {t('legal.terms.lastUpdated', { date: UPDATED })}
      </p>

      <section className="space-y-5">
        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.terms.agreement.title')}</h2>
          <p>{t('legal.terms.agreement.body', { site: SITE })}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.terms.accounts.title')}</h2>
          <p>{t('legal.terms.accounts.body')}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.terms.acceptable.title')}</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>{t('legal.terms.acceptable.items.item1')}</li>
            <li>{t('legal.terms.acceptable.items.item2')}</li>
            <li>{t('legal.terms.acceptable.items.item3')}</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.terms.ownership.title')}</h2>
          <p>{t('legal.terms.ownership.body', { site: SITE })}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.terms.changes.title')}</h2>
          <p>{t('legal.terms.changes.body')}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.terms.disclaimer.title')}</h2>
          <p>{t('legal.terms.disclaimer.body')}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.terms.termination.title')}</h2>
          <p>{t('legal.terms.termination.body')}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.terms.law.title')}</h2>
          <p>{t('legal.terms.law.body')}</p>
        </div>
      </section>
    </div>
  );
}
